import { useRef } from "react";
import "./editorialForms.css";

export default function StickerForm({ data, onChange }) {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange({ 
          ...data, 
          stickerFile: file, 
          stickerFileName: file.name,
          stickerPreview: reader.result 
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const stickerPacks = [
    { id: "emotions", name: "Emocoes", count: 24 },
    { id: "animals", name: "Animais", count: 32 },
    { id: "food", name: "Comida", count: 28 },
    { id: "love", name: "Amor", count: 20 },
    { id: "party", name: "Festa", count: 18 },
    { id: "work", name: "Trabalho", count: 22 },
    { id: "sports", name: "Esportes", count: 26 },
    { id: "memes", name: "Memes", count: 40 },
  ];

  return (
    <div className="editorial_form sticker_form">
      <div className="editorial_form_section">
        <label>Tipo de Sticker</label>
        <select
          value={data?.stickerType || "existing"}
          onChange={(e) => onChange({ ...data, stickerType: e.target.value })}
        >
          <option value="existing">Usar sticker existente</option>
          <option value="custom">Criar sticker personalizado</option>
        </select>
      </div>

      {data?.stickerType !== "custom" && (
        <div className="editorial_form_section">
          <label>Pacote de Stickers</label>
          <div className="sticker_packs">
            {stickerPacks.map((pack) => (
              <div
                key={pack.id}
                className={`sticker_pack_item ${
                  data?.stickerPack === pack.id ? "selected" : ""
                }`}
                onClick={() => onChange({ ...data, stickerPack: pack.id })}
              >
                <span className="pack_name">{pack.name}</span>
                <span className="pack_count">{pack.count}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {data?.stickerType === "custom" && (
        <>
          <div className="editorial_form_section">
            <label>
              Upload do Sticker <span className="required">*</span>
            </label>
            <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*,.png,.jpg,.jpeg,.gif,.webp"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              {data?.stickerPreview ? (
                <div className="file_selected sticker_preview">
                  <img src={data.stickerPreview} alt="Preview" style={{ maxWidth: "150px", maxHeight: "150px" }} />
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onChange({ ...data, stickerFile: null, stickerFileName: null, stickerPreview: null });
                    }}
                    className="file_remove_btn"
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <div className="file_placeholder">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
                  </svg>
                  <p>Clique para fazer upload do sticker</p>
                  <span>PNG, JPG, GIF, WEBP</span>
                </div>
              )}
            </div>
          </div>

          <div className="editorial_form_section">
            <label>Nome do Sticker</label>
            <input
              type="text"
              placeholder="De um nome ao seu sticker..."
              value={data?.stickerName || ""}
              onChange={(e) => onChange({ ...data, stickerName: e.target.value })}
              maxLength={50}
            />
          </div>

          <div className="editorial_form_section">
            <label>Tags (para busca)</label>
            <input
              type="text"
              placeholder="feliz, sorriso, alegria"
              value={data?.tags || ""}
              onChange={(e) => onChange({ ...data, tags: e.target.value })}
            />
          </div>
        </>
      )}

      <div className="editorial_form_section">
        <label>Opcoes</label>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isAnimated"
            checked={data?.isAnimated || false}
            onChange={(e) =>
              onChange({ ...data, isAnimated: e.target.checked })
            }
          />
          <label htmlFor="isAnimated">Sticker animado</label>
        </div>
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="addToPack"
            checked={data?.addToPersonalPack || false}
            onChange={(e) =>
              onChange({ ...data, addToPersonalPack: e.target.checked })
            }
          />
          <label htmlFor="addToPack">Adicionar ao meu pacote pessoal</label>
        </div>
      </div>

      <div className="editorial_form_tip sticker_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM17 11h-4v4h-2v-4H7V9h4V5h2v4h4v2z" />
        </svg>
        <span>
          Stickers sao imagens PNG transparentes. O tamanho recomendado e
          512x512 pixels.
        </span>
      </div>
    </div>
  );
}
